<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          Edit Offers
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-select
                outlined
                v-model="form.offers_type"
                label="Offer type"
                prepend-inner-icon="mdi-arrow-expand-all"
                clearable
                :items="offerTypeItems"
                :error-messages="errors.offers_type"
              ></v-select>
            </v-col>

            <v-col sm="4">
              <v-text-field
                v-model="form.description"
                outlined
                label="Description"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.url"
                outlined
                label="URL"
                prepend-inner-icon="mdi-link"
              ></v-text-field>
            </v-col>

            <v-col sm="4">
              <v-text-field
                v-model="form.percent"
                outlined
                label="Percentage"
                prepend-inner-icon="mdi-percent"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.value"
                outlined
                label="Value"
                prepend-inner-icon="mdi-cash"
              ></v-text-field>
            </v-col>

            <v-col sm="4">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.start_date"
                    label="Start Date *"
                    prepend-inner-icon="mdi-calendar"
                    :error-messages="errors.start_date"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  :min="nowDate"
                  v-model="form.start_date"
                  @input="menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col sm="4">
              <v-menu
                v-model="menu_three"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.end_date"
                    label="End Date *"
                    prepend-inner-icon="mdi-calendar"
                    :error-messages="errors.end_date"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  :min="form.start_date"
                  v-model="form.end_date"
                  @input="menu_three = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <v-divider class="my-5"></v-divider>

          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Offer Details
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "OfferEditPage",
  data() {
    return {
      form: {
        offers_type: "", // Bound to dropdown
        description: "",
        url: "",
        percent: "",
        value: "",
        start_date: "",
        end_date: "",
      },
      offerTypeItems: [
        { text: "Web", value: "web" },
        { text: "Mobile", value: "mobile" },
      ],
      isLoading: false,
      menu: false,
      menu_three: false,
      nowDate: new Date().toISOString().substr(0, 10),
      errors: {
        offers_type: null,
        start_date: null,
        end_date: null,
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      try {
        const encryptedId = this.$route.params.offerId;
        const response = await axios.get(`/offers/${encryptedId}`);
        this.form = response.data.data;
        // Ensure the offers_type is valid
        this.old_json = response.data.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this.isLoading = false;
      }
    },
    async save() {
      this.isLoading = true;
      try {
        await axios.patch(`/offers/${this.$route.params.offerId}`, this.form);
        // Perform additional actions if necessary
      } catch (error) {
        console.error("Error saving offer:", error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.v-btn {
  margin-top: 10px;
}
</style>
